import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import redirects from '@/redirects.json';

const RedirectHandler = () => {
    const { slug } = useParams<{ slug: string }>();
    const navigate = useNavigate();

    useEffect(() => {
        if (!slug) {
            navigate('/katalog', { replace: true });
            return;
        }

        // Clean trailing slash if present (slug usually doesn't have it from react-router, but just in case)
        const cleanSlug = slug.replace(/\/$/, '');

        // Check if we have a mapping
        const targetSlug = (redirects as Record<string, string>)[cleanSlug];

        if (targetSlug) {
            // Redirect to new vendor detail page
            navigate(`/stanek/${targetSlug}`, { replace: true });
        } else {
            // No match found -> Redirect to Katalog (or could be 404, but Katalog is safer UX for old links)
            navigate('/katalog', { replace: true });
        }
    }, [slug, navigate]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-slate-50">
            <div className="text-center">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
                <p className="text-slate-500 font-medium">Přesměrovávám na novou adresu...</p>
            </div>
        </div>
    );
};

export default RedirectHandler;
